const Constants = {
  systemTypes: {
    pdn: {
      multiPart: 'PDN001',
    },
  },

  groupsDefinitions: {
    pdn: {
      application: 'PneumaticLine',
    },
  },

  partCategories: {
    pdn: {
      actuator: 'PneumaticCylinder',
      actuatorAoM: 'PneumaticCylinderAoM',
    },
  },
// Routes and shortcuts are generated at build time by buildRoutes.js based on this file, 
// so if you rename these properties or change the path of this file, make sure to update buildRoutes.js accordingly.
  routes: {
    systems: 'systems',
    shortcuts: 'shortcuts',
  },

  shortcuts: {
    pdnManifold: 'new-pdn-manifold',
    pdnApplication: 'new-pdn-application',
    pdnActuator: 'new-pdn-actuator',
    pdnActuatorAoM: 'new-pdn-actuator-aom',
  },

  sessionStorageKeys: {
    autoExecAction: 'autoExecAction',
    addPartDialogSelection: 'addPartDialogSelection',
    autoCreateGroupUniqueName: 'autoCreateGroupUniqueName',
    autoCreatePartCategoryName: 'autoCreatePartCategoryName',
  },

  autoExecActions: {
    showAddPartDialog: 'showAddPartDialog',
    selectManifoldAddPartDialog: 'selectManifoldAddPartDialog',
    selectApplicationAddPartDialog: 'selectApplicationAddPartDialog',
    launchSizingTool: 'launchSizingTool',
  },
};

export default Constants;
